<script>
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import BankMixin from '@/mixins/bankMixin'

export default {
  name: 'OfferEditMixin',
  mixins: [ApiErrorMixin, BankMixin],
  data: () => ({
    selectedLog: null,
    displayOfferCreateModal: false,
    // selectedLog: {
    //   id: null,
    //   gender: null,
    //   laborer: null,
    //   isTeamAccessLevel: null,
    //   description: null,
    // },
  }),
  methods: {
    onCreatedModalShowMode () {
      this.selectedLog = {
        id: null,
        gender: null,
        laborer: null,
        isTeamAccessLevel: null,
      }
      this.displayOfferCreateModal = true
    },
    onOpenOfferCreateModal (offer) {
      let state = 3

      if (offer.executor) {
        state = 0
      }
      if (offer.isTeamAccessLevel) {
        state = 1
      }
      if (offer.gender) {
        state = 2
      }

      this.selectedLog = {
        id: offer.id,
        gender: null,
        laborer: null,
        isTeamAccessLevel: null,
        description: offer.clientComment,
        currentState: state,
      }
      this.displayOfferCreateModal = true
    },
    onCloseOfferCreateModal (save, offer, callback) {
      if (save) {
        this.save(offer, callback)
      }
      this.displayOfferCreateModal = false
    },
    async save (offer, callback) {
      const gender = this.selectedLog.gender

      let genderValue
      if (gender && gender.id && gender.id === '-1') {
        genderValue = undefined
      } else if (gender && gender.id) {
        genderValue = gender.id
      }

      this.appLogger.log('dfdfdd')
      this.appLogger.log(this.offer)
      const payload = {
        gender: genderValue,
        isTeamAccessLevel: !!this.selectedLog.isTeamAccessLevel && this.selectedLog.isTeamAccessLevel === 1,
        id: offer.id,
        laborer: null,
        isPublic: null,
        action: offer.action
      }
      if (this.selectedLog.laborer) {
        payload.laborer = { id: this.selectedLog.laborer }
      }

      if (this.selectedLog.laborer) {
        payload.laborer = { id: this.selectedLog.laborer }
      }
      if (!!this.selectedLog.isTeamAccessLevel && this.selectedLog.isTeamAccessLevel === 3) {
        payload.isPublic = true
      }

      try {
        this.showPageLoader()
        const result = await this.$store.dispatch(
          'organization/UpdateOfferAccessLevel',
          payload
        )
        if (result.data && result.data.description && result.data.description.trim() !== '') {
          this.setDisplayNotifier(true)
          this.setNotifierMessage(` ${result.data.description.trim()}`)
        }
        if (callback) {
          callback()
        }
        this.hidePageLoader()
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
      }
    },

  }
}
</script>
